import http from "../http-common";

class DeptDataService {
  getAll() {
    return http.get("/depts");
  }

  get(id) {
    return http.get(`/depts/${id}`);
  }

  create(data) {
    return http.post("/depts", data);
  }

  update(id, data) {
    return http.put(`/depts/${id}`, data);
  }

  delete(id) {
    return http.delete(`/depts/${id}`);
  }

  deleteAll() {
    return http.delete(`/depts`);
  }
}

export default new DeptDataService();
